export default "__VITE_ASSET__d9ee69f2__"